import React from 'react';
import { formStepsExternal, formStepsInAndEx } from './wizardItems';
import { IWizardItem } from './components/Wizard';

// Total number of steps in case *internal + external(optional)* documents varies between 4 and 5:
// - 4 steps - when there are no segments in the template;
// - 5 steps - when there are segments to be filled in.
//
// Total number of steps in case *external* documents is 3,
// but these steps are step 1, step 3 and step 5
// (step 2 and step 4 are skipped in this scenario).
//
// In order to set the correct wizard props here we have to check
// the type of the document and the total steps count on every step after step 1 and step 2.
// On step 1 we pass the initial document details and as a response we receive the total steps count.
// Before this action we don't have the total number of steps.
// Step 2 is not available for external documents and document templates without segments.
// That's why we use this helper on steps 3, 4, 5.
const buildWizardProps = (isExternal: boolean, stepView: number, stepExternal: number, totalSteps: number) => {
  const hasNotSegments = Number(totalSteps) === 4;
  const formSteps = hasNotSegments
    ? formStepsInAndEx.filter((step: IWizardItem, index: number) => index !== 1) // Step 2 is the step with the segments
    : formStepsInAndEx;
  const currStep = hasNotSegments && stepView !== 1 ? stepView - 1 : stepView;
  return {
    currentStep: isExternal ? stepExternal : currStep,
    wizardItems: !isExternal ? formSteps : formStepsExternal,
  };
};

export default buildWizardProps;
